<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toc-title">Table of Contents</p>
<p class="toc1"><a href="#/xhtml/09_Original_Preface">Original Editor’s Preface</a></p>
<p class="toc2">Theodore P. Savas</p>
<p class="toc1"><a href="#/xhtml/11_New_Preface">New Editor’s Preface</a></p>
<p class="toc2">Theodore P. Savas</p>
<p class="toc1"><a href="#/xhtml/12_Introduction">Introduction</a></p>
<p class="toc2">Eric C. Rust</p>
<p class="toc1"><a href="#/xhtml/13_Chapter01">In Memoriam Engelbert Endrass: Castor Mourns Pollox</a></p>
<p class="toc2">Erich Topp</p>
<p class="toc1"><span href="#/xhtml/14_Chapter02" title="Link target outside of Sample">Karl-Friedrich Merten and the Prussian Tradition</span></p>
<p class="toc2">Timothy P. Mulligan</p>
<p class="toc1"><span href="#/xhtml/15_Chapter03" title="Link target outside of Sample">Ralph Kapitsky: Battle in the Caribbean and the Death of U-615</span></p>
<p class="toc2">Gaylord T. M. Kelshall</p>
<p class="toc1"><span href="#/xhtml/16_Chapter04" title="Link target outside of Sample">Fritz Guggenberger: Bavarian U-Boat Ace</span></p>
<p class="toc2">Eric C. Rust</p>
<p class="toc1"><span href="#/xhtml/17_Chapter05" title="Link target outside of Sample">Victor Oehrn: The Ace With No Name</span></p>
<p class="toc2">Jordan Vause</p>
<p class="toc1"><span href="#/xhtml/18_Chapter06" title="Link target outside of Sample">Heinz-Wilhelm Eck: Siegerjustiz and the Peleus Affair</span></p>
<p class="toc2">Dwight R. Messimer</p>
<p class="toc1"><span href="#/xhtml/19_Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc2">*  *  *</p>
<p class="toc3">Bonus Material</p>
<p class="toc1"><span href="#/xhtml/21_Editors_Preface" title="Link target outside of Sample">Editor’s Preface</span></p>
<p class="toc2">from <i>Hunt and Kill: U-505 and the U-Boat War in the Atlantic</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?28614368